import { render, staticRenderFns } from "./PermissionsEditor.vue?vue&type=template&id=6e1b1996&scoped=true"
import script from "./PermissionsEditor.vue?vue&type=script&lang=js"
export * from "./PermissionsEditor.vue?vue&type=script&lang=js"
import style0 from "./PermissionsEditor.vue?vue&type=style&index=0&id=6e1b1996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1b1996",
  null
  
)

export default component.exports